import { waitForPendingWrites } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import { URL_PUBLICA } from '../config/marca';

/**
 * Pide al servidor (función tareas-avisar) que avise al móvil de a quién le
 * acaban de asignar una tarea o le ha llegado el turno. Es de Plus y solo llega
 * a quien tiene la app con las notificaciones activadas: el servidor lo
 * comprueba todo. Nunca falla hacia fuera: si no se puede, no pasa nada.
 */
export function avisarAsignacion(datos: { casaId: string; tareaId: string; motivo: 'asignada' | 'turno' }): void {
  const usuario = auth.currentUser;
  if (!usuario) return;
  (async () => {
    // El servidor lee la tarea: primero tiene que haber subido el cambio
    await Promise.race([waitForPendingWrites(db), new Promise(r => setTimeout(r, 15_000))]);
    await fetch(`${URL_PUBLICA}/.netlify/functions/tareas-avisar`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${await usuario.getIdToken()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    });
  })().catch(e => console.warn('No se pudo avisar de la tarea', e));
}
